import { RouteConfig } from 'vue-router';

import NothingButARouterView from './nothing-but-a-router-view.vue';

import ErrorLogout from '../views/auth/error-logout.vue';
import LoginSuccess from '../views/auth/login-success.vue';
import Login from '../views/auth/login.vue';

import DetailArticle from '../views/detail-article/index.vue';
import Main from '../views/main/index.vue';
import MonCompte from '../views/page-tiers/index.vue';
import AjoutAuPanier from '../views/panier/ajout-au-panier/index.vue';
import TableauDeBord from '../views/tableau-de-bord/index.vue';

import { parseRouteParams } from './utils';

import EditAlerte from '../views/alertes/edit-alerte.vue';
import SyntheseAlertes from '../views/alertes/synthese-alertes.vue';

import SynthesePanier from '../views/panier/index.vue';

import HistoriqueCommandes from '../views/historique-commandes/index.vue';

import PolitiqueConfidentitalite from '../views/infos/confidentialite.vue';
import MentionsLegales from '../views/infos/mentions-legales.vue';
import Nouveautes from '../views/infos/nouveautes.vue';

export class RouteName {
  static LOGIN = 'login';
  static LOGOUT_ERROR = 'error-logout';
  static LOGIN_SUCCESS = 'login-success';

  static MAIN_DASHBOARD = 'main.dashboard';
  static MAIN_MON_COMPTE = 'main.page-tiers';
  static MAIN_DETAIL = 'main.detail-article';

  static MAIN_ALERTE_UTILISATEUR = 'main.synthese-alertes';

  static MAIN_ALERTES_LISTE = 'main.alertes.liste'
  static MAIN_ALERTES_EDIT = 'main.alertes.edit'

  static MAIN_PANIER_AJOUT = 'main.panier.ajout';
  static MAIN_PANIER_MODIF = 'main.panier.modification';
  static MAIN_PANIER = 'main.panier.synthese'

  static MAIN_HISTORIQUE_COMMANDES = 'main.historique_commande'

  static MAIN_INFOS_CONFIDENTIALITE = 'main.infos.confidentialite';
  static MAIN_INFOS_MENTIONS_LEGALES = 'main.infos.mentions-legales';
  static MAIN_NOUVEAUTES = 'main.infos.nouveautes';
}

const routes: Array<RouteConfig> = [
  {
    path: '/auth',
    component: NothingButARouterView,
    children: [
      {
        path: 'login',
        name: RouteName.LOGIN,
        meta: { title: 'Login' },
        component: Login
      },
      {
        path: 'error-logout',
        name: RouteName.LOGOUT_ERROR,
        meta: { title: 'Erreur' },
        component: ErrorLogout,
        props: (route) => parseRouteParams(route)
      },
      {
        path: 'login-success',
        name: RouteName.LOGIN_SUCCESS,
        component: LoginSuccess
      }
    ]
  },
  {
    path: '/',
    name: 'main',
    component: Main,
    meta: { title: 'Tableau de bord' },
    redirect: { name: RouteName.MAIN_DASHBOARD },
    children: [
      {
        path: 'tableau-de-bord',
        name: RouteName.MAIN_DASHBOARD,
        // meta: { title: 'Tableau de bord' },
        component: TableauDeBord
      },
      {
        path: 'synthese-panier',
        name: RouteName.MAIN_PANIER,
        component: SynthesePanier,
        meta: { title: 'Mon panier' },
        props: (route) => parseRouteParams(route)
      },
      {
        path: 'historique-commandes',
        name: RouteName.MAIN_HISTORIQUE_COMMANDES,
        component: HistoriqueCommandes,
        props: (route) => parseRouteParams(route),
        meta: { title: 'Historique commandes' }
      },
      {
        path: 'detail/articles/:idArticle',
        component: NothingButARouterView,
        redirect: { name: RouteName.MAIN_DETAIL },
        children: [
          {
            path: '',
            name: RouteName.MAIN_DETAIL,
            meta: { title: 'Detail article' },
            component: DetailArticle,
            props: (route) => parseRouteParams(route)
          },
          {
            path: 'ajout-au-panier',
            component: NothingButARouterView,
            children: [
              {
                path: '',
                name: RouteName.MAIN_PANIER_AJOUT,
                meta: { title: 'Ajout au panier' },
                component: AjoutAuPanier,
                props: (route) => parseRouteParams(route)
              },
              {
                path: 'edit/:idLignePanier',
                name: RouteName.MAIN_PANIER_MODIF,
                meta: { title: 'Modification panier' },
                component: AjoutAuPanier,
                props: (route) => parseRouteParams(route)
              }
            ]
          }
        ]
      },
      {
        path: 'alertes',
        component: NothingButARouterView,
        redirect: { name: RouteName.MAIN_ALERTES_LISTE },
        children: [
          {
            path: 'liste',
            name: RouteName.MAIN_ALERTES_LISTE,
            meta: { title: 'Alerte utilisateurs' },
            component: SyntheseAlertes
          },
          {
            path: 'edit/:idAlerte',
            name: RouteName.MAIN_ALERTES_EDIT,
            meta: { title: 'Paramètres alerte' },
            props: (route) => parseRouteParams(route),
            component: EditAlerte
          }
        ]
      },
      {
        path: 'mon-compte',
        name: RouteName.MAIN_MON_COMPTE,
        meta: { title: 'Mon compte' },
        component: MonCompte
      },
      {
        path: 'infos',
        redirect: { name: RouteName.MAIN_NOUVEAUTES },
        component: NothingButARouterView,
        children: [
          {
            path: 'nouveautes',
            name: RouteName.MAIN_NOUVEAUTES,
            meta: { title: 'Nouveautés' },
            component: Nouveautes
          },
          {
            path: 'politique-confidentialite',
            name: RouteName.MAIN_INFOS_CONFIDENTIALITE,
            meta: { title: 'Politique de confidentialité' },
            component: PolitiqueConfidentitalite
          },
          {
            path: 'mentions-legales',
            name: RouteName.MAIN_INFOS_MENTIONS_LEGALES,
            meta: { title: 'Mentions légales' },
            component: MentionsLegales
          }
        ]
      }
    ]
  }
];

export default routes;
